/* ==========================================================================
   MATTCH — gaveta de carrinho: barra de brinde + lugar das recomendacoes

   Um unico MutationObserver cuida das duas coisas. Dois scripts com observers
   proprios mexendo no mesmo DOM faziam um desfazer o trabalho do outro a cada
   morph do tema.

   COMO AS RECOMENDACOES FUNCIONAM (importa para nao quebrar de novo)
   O theme.liquid tem uma IIFE que preenche #cart-recs-mount por innerHTML,
   com um MutationObserver proprio no body e a guarda posicional "o mount tem
   filhos?". Mover o .cart-recs para fora do mount deixa o mount vazio e o
   observer do tema injeta outra copia; alem disso surgicalUpdate faz
   replaceWith em cart-items-component e destroi blocos soltos ali dentro.
   A saida e mover o MOUNT INTEIRO, com o conteudo junto.

   POR QUE EXISTE A RAJADA
   O script do tema injeta em 50, 200, 500 e 1000ms depois de cada evento de
   carrinho, e o morph reconstroi a gaveta no meio disso. Como as alteracoes
   proprias rodam com o observer desligado, uma mutacao do tema nessa janela
   passava batido. A rajada repassa nos mesmos tempos e fecha o buraco.

   DE ONDE VEM O VALOR DO CARRINHO
   Tres fontes, da mais rapida para a mais confiavel:
   1. sessionStorage — o total da ultima vez, disponivel antes de qualquer
      rede: a barra ja abre desenhada;
   2. o subtotal que esta na tela (.cart-totals__total-value) — vale para a
      sessao atual sem esperar requisicao;
   3. /cart.js — confirma e corrige.
   Sem 1 e 2, a barra so aparecia depois da resposta da rede, e era isso que
   fazia o "Parabens, voce ganhou seu brinde" demorar a surgir.
   ========================================================================== */
(function () {
  var VALOR_BRINDE = 14900; // R$ 149,00 em centavos
  var DESCRICAO_BRINDE = 'Compre R$ 149 e ganhe uma Bolsa de Linho exclusiva Mattch!';
  var INTERVALO_MINIMO = 300;
  var TEMPOS_RAJADA = [0, 60, 150, 280, 550, 1100, 1700];
  var CHAVE_CACHE = 'mattch:cart-total';

  var totalConhecido = null;
  var ultimaBusca = 0;
  var buscando = false;
  var agendado = null;
  var observador = null;

  var MOEDA = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

  var ICONE =
    '<svg class="mattch-gift-bar__icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M20 12V22H4V12M22 7H2V12H22V7ZM12 22V7M12 7H7.5C6.83696 7 6.20107 6.73661 5.73223 6.26777C5.26339 5.79893 5 5.16304 5 4.5C5 3.83696 5.26339 3.20107 5.73223 2.73223C6.20107 2.26339 6.83696 2 7.5 2C11 2 12 7 12 7ZM12 7H16.5C17.163 7 17.7989 6.73661 18.2678 6.26777C18.7366 5.79893 19 5.16304 19 4.5C19 3.83696 18.7366 3.20107 18.2678 2.73223C17.7989 2.26339 17.163 2 16.5 2C13 2 12 7 12 7Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* ---------------------------------------------------------------- utils */

  function gaveta() {
    return document.querySelector('cart-drawer-component, .cart-drawer');
  }

  function semEco(fn) {
    if (observador) observador.disconnect();
    try {
      fn();
    } catch (e) {
      /* nunca deixa um erro daqui derrubar o resto da pagina */
    }
    if (observador) {
      observador.observe(document.body, { childList: true, subtree: true });
    }
  }

  function lerCache() {
    try {
      var v = window.sessionStorage.getItem(CHAVE_CACHE);
      return v == null ? null : parseInt(v, 10);
    } catch (e) {
      return null;
    }
  }

  function gravarCache(total) {
    try {
      window.sessionStorage.setItem(CHAVE_CACHE, String(total));
    } catch (e) {
      /* modo privado, cota cheia: seguir sem cache */
    }
  }

  // "R$ 1.800,00" -> 180000 centavos
  function lerTotalDaTela() {
    var el = document.querySelector('[data-cart-subtotal], .cart-totals__total-value');
    if (!el) return null;

    var texto = String(el.textContent || '').replace(/[^0-9.,-]/g, '').trim();
    if (!texto) return null;

    var n = parseFloat(texto.replace(/\./g, '').replace(',', '.'));
    if (!isFinite(n)) return null;

    return Math.round(n * 100);
  }

  function definirTotal(total) {
    if (total == null || !isFinite(total)) return false;
    if (total === totalConhecido) return false;
    totalConhecido = total;
    gravarCache(total);
    return true;
  }

  /* ------------------------------------------------------- barra de brinde */

  function conteudo(total) {
    var atingiu = total >= VALOR_BRINDE;
    var progresso = Math.min((total / VALOR_BRINDE) * 100, 100);
    var mensagem = atingiu
      ? '<div class="mattch-gift-bar__message mattch-gift-bar__message--success">Parabéns! Você ganhou seu <strong>brinde exclusivo + Frete Grátis</strong></div>'
      : '<div class="mattch-gift-bar__message">Faltam <strong>' +
        MOEDA.format((VALOR_BRINDE - total) / 100) +
        '</strong> para você ganhar seu <strong>brinde exclusivo</strong></div>';

    return (
      '<div class="mattch-gift-bar__top">' + mensagem + ICONE + '</div>' +
      '<div class="mattch-gift-bar__track">' +
      '<div class="mattch-gift-bar__fill" style="width: ' + progresso + '%;">' +
      '<span class="mattch-gift-bar__dot"></span></div></div>' +
      '<div class="mattch-gift-bar__description">' + DESCRICAO_BRINDE + '</div>'
    );
  }

  function ancora(g) {
    var cabecalho = g.querySelector('.cart-drawer__header');
    if (cabecalho && cabecalho.parentNode) {
      return { modo: 'apos-cabecalho', ref: cabecalho };
    }

    var itens = g.querySelector(
      '.cart-drawer__items, scroll-hint.cart-drawer__items, .cart-items-component'
    );
    if (itens && itens.parentNode) {
      return { modo: 'antes-itens', ref: itens };
    }

    return null;
  }

  function noLugar(barra, alvo) {
    if (alvo.modo === 'apos-cabecalho') return alvo.ref.nextElementSibling === barra;
    return barra.nextElementSibling === alvo.ref;
  }

  function pintarBarra(g, total) {
    if (total == null) return;

    var alvo = ancora(g);
    if (!alvo) return;

    var barra = g.querySelector('.mattch-gift-bar');
    var chave = String(total);

    if (barra && barra.dataset.mtTotal === chave && noLugar(barra, alvo)) return;

    if (!barra) {
      barra = document.createElement('div');
      barra.className = 'mattch-gift-bar';
    }

    if (barra.dataset.mtTotal !== chave) {
      barra.innerHTML = conteudo(total);
      barra.dataset.mtTotal = chave;
    }

    if (!noLugar(barra, alvo)) {
      if (alvo.modo === 'apos-cabecalho') {
        alvo.ref.parentNode.insertBefore(barra, alvo.ref.nextSibling);
      } else {
        alvo.ref.parentNode.insertBefore(barra, alvo.ref);
      }
    }
  }

  /* -------------------------------------------------------- recomendacoes */

  function moverRecs(g) {
    var itens = g.querySelector('.cart-drawer__items');
    if (!itens) return;

    var mount = document.getElementById('cart-recs-mount');
    if (!mount || !mount.innerHTML.trim()) return;

    if (mount.parentNode === itens && mount === itens.lastElementChild) return;

    itens.appendChild(mount);
  }

  /* ------------------------------------------------------------ orquestra */

  function arrumar() {
    var g = gaveta();
    if (!g) return;

    // o subtotal na tela e mais novo que o cache e nao custa requisicao
    definirTotal(lerTotalDaTela());

    semEco(function () {
      pintarBarra(g, totalConhecido);
      moverRecs(g);
    });
  }

  function buscar(forcar) {
    var agora = Date.now();
    if (buscando) return;
    if (!forcar && agora - ultimaBusca < INTERVALO_MINIMO) return;
    if (!gaveta()) return;

    buscando = true;
    ultimaBusca = agora;

    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (carrinho) {
        definirTotal(carrinho.total_price);
        arrumar();
      })
      .catch(function () { /* mantem o que esta na tela */ })
      .then(function () { buscando = false; });
  }

  function agendar() {
    if (agendado) return;
    agendado = setTimeout(function () {
      agendado = null;
      buscar(false);
    }, 120);
  }

  function repor() {
    arrumar();
    agendar();
  }

  function rajada() {
    arrumar();          // desenha na hora, com cache ou com o subtotal da tela
    buscar(true);       // e confirma pela rede
    TEMPOS_RAJADA.forEach(function (ms) {
      setTimeout(arrumar, ms);
    });
    setTimeout(function () { buscar(true); }, 250);
    setTimeout(function () { buscar(true); }, 900);
  }

  function iniciar() {
    // valor da ultima vez: a barra ja nasce desenhada, antes de qualquer rede
    totalConhecido = lerCache();

    observador = new MutationObserver(repor);
    observador.observe(document.body, { childList: true, subtree: true });

    [
      'cart:update',      // Horizon
      'cart:updated',
      'cart:refresh',
      'cart:change',
      'cart:build',
      'cart:item-added',
      'cart:error',
      'dialog:open',
      'dialog:close'
    ].forEach(function (evento) {
      document.addEventListener(evento, rajada);
    });

    // o clique no icone do carrinho antecede o dialog:open; comecar aqui
    // adianta o primeiro desenho da barra
    document.addEventListener(
      'click',
      function (e) {
        if (e.target && e.target.closest && e.target.closest('.header-actions__action, cart-icon, .cart-drawer__close-button')) {
          rajada();
        }
      },
      true
    );

    rajada();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
